import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Confirmation } from './types/confirmation';
import { ManageActivityLogsService } from '../../../../../manage-survey-tabs/services/manage-activity-logs/manage-activity-logs.service';

type Colors = 'white' | 'warning' | 'pink';

@Component({
  selector: 'ps-ui-cpi-override-confirmation',
  templateUrl: './cpi-override-confirmation.component.html',
  styleUrls: ['./cpi-override-confirmation.component.css'],
})
export class CpiOverrideConfirmationComponent implements OnChanges, OnInit {
  @Input()
  public type: 'global' | 'selective' | 'buyer' = 'global';

  @Input()
  public confirmed = false;

  @Input()
  public surveyId: number;

  @Input()
  public newCpi: string;

  @Input()
  public color: Colors = 'white';

  @Input()
  public borderless = false;

  @Input()
  public bold = false;

  @Output()
  public confirm = new EventEmitter<Confirmation>();

  public confirmation!: Confirmation;
  public waspConfirmation = [];

  constructor(private _activity: ManageActivityLogsService) {}

  public ngOnInit(): void {
    this.confirmation = this._defineConfirmation();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.confirmation = this._defineConfirmation();
  }

  private _defineConfirmation(): Confirmation {
    switch (this.type) {
      case 'global':
        return new Confirmation(
          'Please confirm the Override CPI value you have entered is accurate.',
          this.confirmed
        );
      case 'selective':
        return new Confirmation(
          'Please confirm the Selective Manual Override CPI value(s) you have entered is/are accurate.',
          this.confirmed
        );
      case 'buyer':
        return new Confirmation(
          'Please confirm that the CPI value you have entered is intended and correct.',
          this.confirmed
        );
    }
  }

  public onConfirm(event: Event): void {
    event.stopPropagation();
    this.confirmation.confirm();
    if (this.surveyId) {
      this._activity
        .sendHihCpiConfirmation(this.surveyId, this.newCpi)
        .subscribe();
    }
    this.confirm.emit(this.confirmation);
  }
}
